import { useParams } from 'react-router-dom';
import { Dialog, DialogContent} from '@mui/material';
import { useState, useEffect } from "react";

export default function ProjectPage() {
  const { slug } = useParams();

  const [project, setProject] = useState(null);
  const [media, setMedia] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [loginError, setLoginError] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [deletePhoto, setDeletePhoto] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handlePrev = () => {
    setOpenIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setOpenIndex((prev) => (prev < media.length - 1 ? prev + 1 : prev));
  };

  const closeDialog = () => setOpenIndex(null);

  useEffect(() => {
    if (!slug) return;
    const id = slug.split("-").pop();
    console.log("ID:", id);
    fetch(`/api/projects/${id}`)
        .then(async res => {
            const text = await res.text();
            console.log("Response:", text);
            try {
            return JSON.parse(text);
            } catch (err) {
            console.error("Invalid JSON", err);
            throw err;
            }
        })
      .then(data => {
        setProject(data.project);
        setMedia(data.media);
      });
  }, [slug]);

  const handleLogin = async () => {
    const res = await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: passwordInput }),
    });
    const result = await res.json();
    if (res.ok && result.auth === true) {
      console.log("Login success");
      setIsAdmin(true);
      console.log(isAdmin);
      setMenuOpen(false);
    } else {
      console.log("Login error");
      setLoginError("Incorrect password.");
    }
  }

  const handleLogout = async () => {
    await fetch("/api/logout", { method: "GET" }); // Rimuove il cookie lato server
    setIsAdmin(false);
    setMenuOpen(false);
  };

  const confirmDelete = async () => {
    if (!deletePhoto) return;
    setIsDeleting(true);

    try {
      const res = await fetch("/api/delete", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          project_id: deletePhoto.project_id,
          index_within_project: deletePhoto.index_within_project,
        }),
      });

      if (res.ok) {
        // aggiorna lo stato della gallery, oppure ricarica
        window.location.reload(); // oppure filtra via localmente
      } else {
        console.error("Errore durante la cancellazione.");
      }
    } catch (err) {
      console.error("Errore rete:", err);
    } finally {
      setDeletePhoto(null);
      setIsDeleting(false);
    }
  };

  if (!project) return <div>Caricamento...</div>;

  return (
    <div className="p-4 max-w-md mx-auto">
      {/* Menu Bar */}
      <header className="flex justify-between items-center pb-4 border-b">
        <h1 className="text-lg font-bold" onClick={() => window.location.href = "/"}> Giorgio Calcaterra </h1>
        <button className="text-lg right-0" onClick={() => setMenuOpen(true)}>☰</button>
      </header>
      {/* Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center p-4">
          {/*<button className="absolute top-4 right-4 text-2xl" onClick={() => setMenuOpen(false)}>✖</button>}
          {/* X close button */}
          <button
                className="absolute top-2 right-2 text-black hover:text-red-700"
                onClick={() => setMenuOpen(false)}
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          {/*TODO: <button classname="" onClick={window.location.href = "/upload"}>Upload page</button>*/}
          {isAdmin && (
            <>
              <h2 className="text-xl font-bold mb-4">Sei autenticato</h2>
              <button
                type="button"
                className="mt-4 text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
                onClick={() => handleLogout()} 
              >
                Logout
              </button>
            </>
          )}
          {!isAdmin && (
            <>
              <h2 className="text-xl font-bold mb-4">Admin Login</h2>
              <input
                type="password"
                placeholder="Enter password"
                className="border border-gray-300 p-2 rounded w-full max-w-xs mb-2"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
              />
              <button
                type="button"
                className="mt-4 text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                onClick={handleLogin}
              >
                Login
              </button>
              {loginError && <p className="text-red-500 mt-2">{loginError}</p>}
            </>
          )}
        </div>
      )}

        {/* Project Details */}
        <div className="text-center my-4">
            <h1 className="text-3xl font-bold mb-2">{project.title}</h1>
            <p className="text-gray-600 mb-1">{project.location} — {project.date}</p>
            <p className="mb-6">{project.description}</p>
            {/*<img src={media[0].image_url} alt="img" className="w-full h-auto rounded shadow mb-4" />*/}

            <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-0 mt-8">
              {media.map((item, index) => (
                <div key={index} className="relative">
                  {isAdmin && (
                    <button
                      className="absolute top-1 left-1 bg-white text-black rounded p-1 text-xs z-10 border"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeletePhoto({ ...item });
                      }}
                    >
                      🗑️
                    </button>
                  )}

                  {item.image_url.match(/\.(mp4|webm|ogg)$/i) ? (
                    <video
                      onClick={() => setOpenIndex(index)}
                      className="w-auto h-auto rounded shadow cursor-pointer"
                      muted
                    >
                      <source src={item.image_url} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={item.image_url}
                      alt="image_content"
                      onClick={() => setOpenIndex(index)}
                      className="w-auto h-auto rounded shadow cursor-pointer"
                    />
                  )}
                </div>
              ))}
            </div>

            {/* Overlay Dialog */}
            {openIndex !== null && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center">
                <button
                    onClick={closeDialog}
                    className="absolute top-4 right-4 text-white text-3xl font-bold"
                >
                    &times;
                </button>

                <button
                    onClick={handlePrev}
                    disabled={openIndex === 0}
                    className="absolute left-4 text-white text-4xl font-bold"
                >
                    &#8592;
                </button>

                <div className="max-w-4xl max-h-[90vh] w-full flex justify-center items-center">
                    {media[openIndex].image_url.match(/\.(mp4|webm|ogg)$/i) ? (
                    <video controls className="max-h-[90vh] w-auto rounded shadow-lg">
                        <source src={media[openIndex].image_url} type="video/mp4" />
                    </video>
                    ) : (
                    <img
                        src={media[openIndex].image_url}
                        alt="zoomed"
                        className="max-h-[90vh] w-auto rounded shadow-lg"
                    />
                    )}
                </div>

                <button
                    onClick={handleNext}
                    disabled={openIndex === media.length - 1}
                    className="absolute right-4 text-white text-4xl font-bold"
                >
                    &#8594;
                </button>
                </div>
            )}
      </div>
      {/* Dialog di conferma cancellazione */}
      {deletePhoto && (
        <Dialog open={true} onOpenChange={() => setDeletePhoto(null)} className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                  {/* X close button */}
                    <button
                        className="absolute top-2 right-2 text-black hover:text-red-700"
                        onClick={() => setDeletePhoto(null)}
                      >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                      </svg>
                    </button>
                  <DialogContent className="bg-white p-6 rounded shadow-lg max-w-sm w-full text-center">
                    <h2 className="text-lg font-bold mb-2">Conferma eliminazione</h2>
                    <p className="mb-4">Vuoi davvero eliminare questa risorsa?</p>
                    <div className="flex justify-center gap-4">
                      <button
                        onClick={() => setDeletePhoto(null)}
                        className="bg-gray-300 px-4 py-2 rounded"
                      >
                        Annulla
                      </button>
                      <button
                        onClick={confirmDelete}
                        className="bg-red-600 text-white p-16 rounded"
                        disabled={isDeleting}
                      >
                        {isDeleting ? "Eliminazione..." : "Elimina"}
                      </button>
                    </div>
                  </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
